import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { buildDocumentPreviewRows } from '@/features/ui/DocumentsData/model/preview';

import { ConditionView, Grid, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { useERZDocumentTypes } from '@/modules/erz/helpers';

import { DocumentTypeCode } from '@/api/types';

import { DocumentsData } from '../../DocumentsData';

export const TechnicalConditionData: React.FC<StepProps> = ({ currentRequestId, prev, next, onStepDraftSave }) => {
  const { data: documentTypeEntities = [], isLoading: isTechnicalConditionLoading } = useERZDocumentTypes({
    allowedDocumentTypeCodes: [DocumentTypeCode.TECHNICAL_CONDITION],
  });

  const safeRequestId = currentRequestId ?? '';

  return (
    <ConditionView if={!isTechnicalConditionLoading} else={<Loader />}>
      <FormBlock title="Документ про огляд технічного стану та/або відстріл">
        <DocumentsData
          withUploader
          documentTypeSelectDisabled
          documentTypeEntities={documentTypeEntities ?? []}
          maxDocumentsCount={1}
          name="confirmTechnicalConditionDocument"
          request_id={safeRequestId}
          onSaveDraft={onStepDraftSave}
          documentsRequired
        />
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </ConditionView>
  );
};

export const TechnicalConditionDataPreview: React.FC = () => {
  const { getValues } = useFormContext();
  const { confirmTechnicalConditionDocument } = getValues();
  const doc = Array.isArray(confirmTechnicalConditionDocument) ? confirmTechnicalConditionDocument[0] : undefined;
  const rows = buildDocumentPreviewRows(doc, 'Документ, який підтверджує відповідність технічного стану та відстріл');

  return <Grid title="Документ про огляд технічного стану та/або відстріл" data={rows} />;
};
